import React, { FC } from 'react';

import { useNavigate, useParams } from 'react-router-dom';

import { SubNav, NavListSelect } from '../../components';
import TableLayout from '../../components/tableLayout/TableLayout';

import GameWinningGoals from './components/gameWinningGoals/GameWinningGoals';
import { Component as StanleyCupWinners } from './components/stanleyCupWinners';
import views from './views';

import { StanleyCupContentContainer } from './styles';

const StanleyCup: FC = () => {
    const navigate = useNavigate();
    const params = useParams();

    const view = params.view as string;
    const selectedView = views.find((x) => x.value === view) || views[0];
    const selectedLinkValue = (selectedNav) => {
        navigate(`/awards/stanley-cup/${selectedNav.value}`);
    };

    const navListView = (
        <NavListSelect
            label="View"
            selected={selectedView}
            availableOptions={views}
            parent="awards/stanley-cup"
            selectFunction={selectedLinkValue}
            className="full-width"
        />
    );
    const navigation = <SubNav>{navListView}</SubNav>;

    return (
        <>
            {selectedView.showStanleyCupWinners && (
                <StanleyCupWinners navListView={navListView} selectedView={selectedView} />
            )}

            {selectedView.showGameWinningGoals && (
                <TableLayout
                    header={selectedView.label}
                    templateKey={selectedView.templateKey}
                    templateKeyDescription={selectedView.templateKey}
                    subNav={navigation}
                >
                    <GameWinningGoals />
                </TableLayout>
            )}

            {selectedView.showContentModules && (
                <StanleyCupContentContainer>
                    <TableLayout
                        header={selectedView.label}
                        templateKey={selectedView.templateKey}
                        templateKeyDescription={selectedView.templateKey}
                        subNav={navigation}
                    />
                </StanleyCupContentContainer>
            )}
        </>
    );
};

export default StanleyCup;
